import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getSalesforceConfig = () =>
  call(websocketFetch, 'get_salesforce_config', { version: 1 });
